import React from "react";
import { View, StyleSheet, TouchableOpacity } from "react-native";
import Text from "@components/CustomText";
import color from "@constants/color";
import t from "@constants/localization";

interface ListHeaderProps {
  currentTab: string;
  setCurrentTab: (tab: string) => void;
  showReturnData: boolean;
  showDeliveryData: boolean;
  TabEnum: {
    DELIVERY: string;
    RETURN: string;
  };
  PATH: string;
  isLoading?: boolean;
}

const ListHeader: React.FC<ListHeaderProps> = ({
  currentTab,
  setCurrentTab,
  showReturnData,
  showDeliveryData,
  TabEnum,
  PATH,
  isLoading,
}) => {
  return !isLoading ? (
    <View style={styles.container}>
      <View style={styles.tabContainer}>
        {showReturnData ? (
          <TouchableOpacity
            testID="dro-return-tab"
            onPress={() => setCurrentTab(TabEnum.RETURN)}
            style={[
              styles.tabBtn,
              currentTab === TabEnum.RETURN
                ? styles.activeTab
                : styles.inactiveTab,
            ]}
          >
            <Text
              variant="body_text_2"
              style={
                currentTab === TabEnum.RETURN
                  ? styles.activeTabText
                  : styles.inactiveTabText
              }
            >
              {t(`${PATH}/components/Tabs/routes/return`)}
            </Text>
          </TouchableOpacity>
        ) : null}
        {showDeliveryData ? (
          <TouchableOpacity
            testID="dro-delivery-tab"
            onPress={() => setCurrentTab(TabEnum.DELIVERY)}
            style={[
              styles.tabBtn,
              currentTab === TabEnum.DELIVERY
                ? styles.activeTab
                : styles.inactiveTab,
            ]}
          >
            <Text
              variant="body_text_2"
              style={
                currentTab === TabEnum.DELIVERY
                  ? styles.activeTabText
                  : styles.inactiveTabText
              }
            >
              {t(`${PATH}/components/Tabs/routes/delivery`)}
            </Text>
          </TouchableOpacity>
        ) : null}
      </View>
    </View>
  ) : null;
};

const styles = StyleSheet.create({
  container: {
    backgroundColor: color.white,
    top: -2,
  },
  tabContainer: {
    flexDirection: "row",
    justifyContent: "space-between",
    margin: 10,
  },
  tabBtn: {
    flex: 1,
    padding: 10,
    alignItems: "center",
    marginHorizontal: 8,
    borderWidth: 1,
    borderRadius: 30,
  },
  activeTab: {
    backgroundColor: color.mediumBlack,
    borderColor: color.mediumBlack,
  },
  inactiveTab: {
    backgroundColor: color.white,
    borderColor: color.black02,
  },
  activeTabText: {
    color: color.white,
  },
  inactiveTabText: {
    color: color.black,
  },
});

export default ListHeader;
